import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getCategories = () => api.get("/categories").then((r) => r.data);
export const getProducts = (params = {}) => api.get("/products", { params }).then((r) => r.data);
export const getProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const getReviews = (product_slug) =>
    api.get("/reviews", { params: product_slug ? { product_slug } : {} }).then((r) => r.data);
export const getJournal = () => api.get("/journal").then((r) => r.data);
export const getJournalPost = (slug) => api.get(`/journal/${slug}`).then((r) => r.data);
export const sendContact = (data) => api.post("/contact", data).then((r) => r.data);
export const listReviews = (product_slug) =>
    api.get("/reviews", { params: product_slug ? { product_slug } : {} }).then((r) => r.data);
export const submitReview = (data) => api.post("/reviews", data).then((r) => r.data);
export const createOrder = (data) => api.post("/orders", data).then((r) => r.data);
